<template>
  <el-main>
    <!-- 類型選擇 -->
    <div>
      <el-radio-group
        v-if="!data1.sort.status"
        v-model="nowCategoryId"
        size="medium"
      >
        <el-radio-button
          v-for="item in data0.categoryList"
          :key="item.name"
          :label="item.id"
          >{{ item.name }}</el-radio-button
        >

        <!-- 編輯分類 -->
      </el-radio-group>
      <el-button
        type="noBorder"
        size="medium"
        v-if="!data1.sort.status"
        @click="categoryEditFunction()"
        ><i class="el-icon-edit-outline"></i> 編輯分類</el-button
      >
    </div>

    <!--編輯分類 dialog-->
    <el-dialog
      title="新增分類"
      :visible.sync="data0.editDialogVisible"
      width="60%"
      :close-on-click-modal="false"
      @closed="data0EditCancel()"
    >
      <!-- coustom dialog title -->
      <div slot="title" class="header-title">
        <div style="font-size: 20px; color:#232f4c">新增分類</div>
        <br />
        <!-- data0 add btn -->
        <el-button
          type="primary"
          v-if="data0.sort.status"
          @click="data0.addForm0.dialogVisible = true"
          >+ 分類</el-button
        >
      </div>
      <div class="el-dialog-body">
        <!--data0 table -->
        <el-table :data="data0.categoryList" style="width: 100% ">
          <template slot="empty">
            <span> <i class="el-icon-menu" /> 增加分類 </span>
          </template>
          <el-table-column label="排序">
            <template slot-scope="scope">
              <div v-if="data0.sort.status">
                <el-button
                  v-if="scope.$index !== 0"
                  icon="el-icon-top"
                  @click="data0SortUpdateIndex(scope.$index, scope.$index - 1)"
                ></el-button>
                <el-button
                  v-if="scope.$index !== data0.categoryList.length - 1"
                  icon="el-icon-bottom"
                  @click="data0SortUpdateIndex(scope.$index, scope.$index + 1)"
                ></el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="分類名稱">
            <template slot-scope="scope">
              <i class="el-icon-menu" /> {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button @click="data0UpdateForm0DialogOpen(scope.$index)"
                ><i class="el-icon-edit" /> 編輯</el-button
              >
              <el-button @click="data0Delete(scope.$index)">
                <i class="el-icon-delete" /> 刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <br /><br />
      <!-- coustom dialog-footer -->
      <div slot="footer" class="dialog-footer">
        <div class="formSubmitBtnBox">
          <el-button @click="data0EditCancel()">取消</el-button>
          <el-button type="primary" @click="data0EditConfirm()">確定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- data0 add dialog -->
    <el-dialog
      title="新增"
      :visible.sync="data0.addForm0.dialogVisible"
      width="30%"
      @closed="data0AddForm0DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data0.addForm0.data"
        status-icon
        :rules="data0.addForm0.rules"
        ref="data0AddForm0"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data0.addForm0.loading"
        @submit.native.prevent
      >
        <el-form-item label="分類名稱" prop="name">
          <el-input
            type="text"
            v-model.trim="data0.addForm0.data.name"
            autocomplete="off"
            maxlength="60"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert
            v-show="data0.addForm0.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data0.addForm0.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data0.addForm0.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data0AddForm0Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- data0 update dialog -->
    <el-dialog
      title="編輯"
      :visible.sync="data0.updateForm0.dialogVisible"
      width="30%"
      @closed="data0UpdateForm0DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data0.updateForm0.data"
        status-icon
        :rules="data0.updateForm0.rules"
        ref="data0UpdateForm0"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data0.updateForm0.loading"
        @submit.native.prevent
      >
        <el-form-item label="分類名稱" prop="name">
          <el-input
            type="text"
            v-model.trim="data0.updateForm0.data.name"
            autocomplete="off"
            maxlength="60"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert
            v-show="data0.updateForm0.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.updateForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data0.updateForm0.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data0UpdateForm0Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 間隔 -->
    <br />
    <!--data1 sort btn-->
    <el-button
      v-if="!data1.sort.status && data1.data.length > 1"
      @click="data1OpenSortFunction()"
      >排序</el-button
    >
    <el-button v-if="data1.sort.status" @click="data1SubmitSort()"
      >確定</el-button
    >
    <el-button v-if="data1.sort.status" @click="data1CloseSortFunction()"
      >取消</el-button
    >
    <!-- data1 add btn -->
    <el-button
      type="primary"
      v-if="!data1.sort.status"
      @click="LinkedAddFunction()"
      >+ 連結</el-button
    >
    <!-- 間隔 -->
    <br /><br />
    <!-- data1 table -->
    <el-table :data="data1.data" style="width: 100%">
      <template slot="empty" v-if="nowCategoryId == 0">
        <span> <i class="el-icon-thumb" /> 請選擇分類 </span>
      </template>
      <template slot="empty" v-else>
        <span> <i class="el-icon-link" /> 增加連結 </span>
      </template>
      <el-table-column label="編號">
        <template slot-scope="scope">
          <div v-if="data1.sort.status">
            <el-button
              v-if="scope.$index !== 0"
              icon="el-icon-top"
              @click="data1SortUpdateIndex(scope.$index, scope.$index - 1)"
            ></el-button>
            <el-button
              v-if="scope.$index !== data1.data.length - 1"
              icon="el-icon-bottom"
              @click="data1SortUpdateIndex(scope.$index, scope.$index + 1)"
            ></el-button>
          </div>
          <div v-if="!data1.sort.status">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="連結名稱">
        <template slot-scope="scope">
          <el-link :href="scope.row.url" target="_blank"
            ><i class="el-icon-link" /> {{ scope.row.name }}
          </el-link></template
        >
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button @click="data1UpdateForm1DialogOpen(scope.$index)"
            ><i class="el-icon-edit" /> 編輯</el-button
          >
          <el-button @click="data1Delete(scope.$index)"
            ><i class="el-icon-delete" /> 刪除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- data1 add dialog -->
    <el-dialog
      title="新增"
      :visible.sync="data1.addForm1.dialogVisible"
      width="30%"
      @closed="data1AddForm1DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.addForm1.data"
        status-icon
        :rules="data1.addForm1.rules"
        ref="data1AddForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.addForm1.loading"
        @submit.native.prevent
      >
        <el-form-item label="連結名稱" prop="name">
          <el-input
            type="text"
            v-model.trim="data1.addForm1.data.name"
            autocomplete="off"
            maxlength="60"
            show-word-limit
            placeholder="請輸入網站名稱"
          ></el-input>
        </el-form-item>
        <el-form-item label="連結" prop="url">
          <el-input
            type="text"
            v-model.trim="data1.addForm1.data.url"
            autocomplete="off"
            placeholder="http://"
          ></el-input>
        </el-form-item>

        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.addForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.addForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data1AddForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- data1 update dialog -->
    <el-dialog
      title="編輯"
      :visible.sync="data1.updateForm1.dialogVisible"
      width="30%"
      @closed="data1UpdateForm1DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.updateForm1.data"
        status-icon
        :rules="data1.updateForm1.rules"
        ref="data1UpdateForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.updateForm1.loading"
        @submit.native.prevent
      >
        <el-form-item label="連結名稱" prop="name">
          <el-input
            type="text"
            v-model.trim="data1.updateForm1.data.name"
            autocomplete="off"
            maxlength="60"
            show-word-limit
            placeholder="請輸入網站名稱"
          ></el-input>
        </el-form-item>
        <el-form-item label="連結" prop="url">
          <el-input
            type="textarea"
            :rows="5"
            v-model.trim="data1.updateForm1.data.url"
            autocomplete="off"
            placeholder="http://"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.updateForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.updateForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.updateForm1.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data1UpdateForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  G_Linked_Category_GetList,
  G_Linked_Category_Add,
  G_Linked_Category_Update,
  G_Linked_Category_Delete,
  G_Linked_Category_Sort,
  G_Linked_GetList,
  G_Linked_Add,
  G_Linked_Update,
  G_Linked_Delete,
  G_Linked_Sort,
} from '@/assets/js/api';

export default {
  data() {
    // 自訂驗證規則 (相同類別名稱無法通過驗證)
    // const sameNameValidate = (rule, value, callback) => {
    //   function match(name) {
    //     return name.name === value;
    //   }
    //   if (this.data0.categoryList.find(match)) {
    //     callback('分類名稱已存在，請重新輸入 ');
    //   } else {
    //     callback();
    //   }
    // };
    // 自訂驗證規則 ( 相同連結名稱無法通過驗證)
    // const sameLinkedValidate = (rule, value, callback) => {
    //   function match(name) {
    //     return name.name === value;
    //   }
    //   if (this.data1.data.find(match)) {
    //     callback('連結名稱已存在，請重新輸入 ');
    //   } else {
    //     callback();
    //   }
    // };

    return {
      nowCategoryId: 0,
      // data0 => 分類資料
      data0: {
        categoryList: [],
        errorMessage: '',
        editDialogVisible: false,
        addForm0: {
          dialogVisible: false,
          loading: false,
          formRef: 'data0AddForm0',
          errorMessage: '',
          data: {
            name: '',
          },
          rules: {
            name: [
              { required: true, message: '請輸入分類名稱 ' },
              { min: 1, max: 60, message: '連結名稱過長' },
            ],
          },
        },
        updateForm0: {
          updateId: 0,
          dialogVisible: false,
          status: false,
          loading: false,
          formRef: 'data0UpdateForm0',
          errorMessage: '',
          data: {
            name: '',
          },
          rules: {
            name: [
              { required: true, message: '請輸入分類名稱 ' },
              { min: 1, max: 60, message: '連結名稱過長' },
            ],
          },
        },
        sort: {
          status: false,

          originalDataTemp: [], // 開始更新時先保留原始資料
        },
      },
      // data1 => 連結的資料
      data1: {
        data: [],
        // 增加的表單
        addForm1: {
          dialogVisible: false,
          loading: false,
          formRef: 'data1AddForm1',
          errorMessage: '',
          data: {
            name: '',
            url: '',
          },
          rules: {
            name: [
              { required: true, message: '請輸入名稱 ' },
              { min: 1, max: 60, message: '連結名稱過長' },
            ],
            url: [{ required: true, message: '請輸入連結' }],
          },
        },
        // 更新的表單
        updateForm1: {
          updateId: 0,
          dialogVisible: false,
          loading: false,
          formRef: 'data1UpdateForm1',
          errorMessage: '',
          data: {
            name: '',
            url: '',
          },
          rules: {
            name: [
              { required: true, message: '請輸入連結名稱' },
              { min: 1, max: 60, message: '連結名稱必須在60個字元內' },
            ],
            url: [{ type: 'url', required: true, message: '請輸入連結' }],
          },
        },
        sort: {
          status: false,
          originalDataTemp: [], // 開始更新時先保留原始資料
        },
      },
    };
  },
  components: {},
  mounted() {
    this.data0GetList(); // 網頁載入get分類
  },
  methods: {
    // data0 get list
    // 撈出所有類別
    data0GetList() {
      G_Linked_Category_GetList()
        .then((res) => {
          this.data0.categoryList = res.data.data;
        })
        .catch((err) => {
          this.data0.errorMessage = err.response.data.message;
        });
    },
    // data1 get list
    // 撈出該類別的連結
    data1GetList() {
      G_Linked_GetList(this.nowCategoryId)
        .then((res) => {
          this.data1.data = res.data.data;
        })
        .catch((err) => {
          this.data1.addForm1.errorMessage = err.response.data.message;
        });
    },

    //  data1 add
    // 清除新增的輸入資料
    data1AddForm1DialogClosed() {
      this.data1.addForm1.loading = false;
      this.$refs[this.data1.addForm1.formRef].resetFields();
      this.data1.addForm1.errorMessage = '';
    },
    // 同名驗證add1
    sameLinkedValidate(input) {
      const flag = this.data1.data.find((name) => name.name === input);
      if (flag) {
        this.$confirm('連結名稱已存在，請輸入別的名稱', '無法新增連結', {
          showConfirmButton: false,
          cancelButtonText: '我知道了',
          type: 'warning',
        })
          .then(() => {})
          .catch(() => {});
        return true;
      }
      return false;
    },
    //  增加連結
    data1AddForm1Submit() {
      if (this.sameLinkedValidate(this.data1.addForm1.data.name)) {
        return;
      }
      this.$refs[this.data1.addForm1.formRef].validate((valid) => {
        this.data1.addForm1.data.categoryId = this.nowCategoryId;
        if (valid) {
          this.data1.addForm1.errorMessage = '';
          this.data1.addForm1.loading = true;
          G_Linked_Add(this.data1.addForm1.data)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
              });
              this.data1.addForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.addForm1.loading = false;
              this.data1.addFrom1.errorMessage = err.response.data.message;
            });
        }
      });
    },

    // data1 update
    // 開啟編輯連結彈窗
    data1UpdateForm1DialogOpen(index) {
      this.data1.updateForm1.data = { ...this.data1.data[index] };
      this.data1.updateForm1.updateId = this.data1.data[index].id;
      this.data1.updateForm1.dialogVisible = true;
    },
    // 關閉編輯連結彈窗
    data1UpdateForm1DialogClosed() {
      this.data1.updateForm1.loading = false;
      this.$refs[this.data1.updateForm1.formRef].resetFields();
      this.data1.updateForm1.updateId = 0;
      this.data1.updateForm1.errorMessage = '';
    },
    // 更新連結
    data1UpdateForm1Submit() {
      if (this.sameLinkedValidate(this.data1.updateForm1.data.name)) {
        return;
      }
      this.$refs[this.data1.updateForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.updateForm1.errorMessage = '';
          this.data1.updateForm1.loading = true;
          G_Linked_Update(
            this.data1.updateForm1.updateId,
            this.data1.updateForm1.data,
          )
            .then(() => {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
              });
              this.data1.updateForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.updateForm1.loading = false;
              this.data1.updateForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },

    // data1 delete
    // 刪除連結
    data1Delete(index) {
      this.$confirm('確定刪除?', '確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          G_Linked_Delete(this.data1.data[index].id)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
              });
              this.data1GetList();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: 'warning',
              });
            });
        })
        .catch(() => {});
    },

    // data1 sort
    // 暫存原本資料
    data1OpenSortFunction() {
      this.data1.sort.status = true;
      this.data1.sort.originalDataTemp = [...this.data1.data];
    },
    // 回復原本資料
    data1CloseSortFunction() {
      this.data1.sort.status = false;
      this.data1.data = [];
      this.data1.data = [...this.data1.sort.originalDataTemp];
    },
    // 更新排序
    data1SortUpdateIndex(originalIndex, newIndex) {
      [this.data1.data[originalIndex], this.data1.data[newIndex]] = [
        this.data1.data[newIndex],
        this.data1.data[originalIndex],
      ];
      const temp = this.data1.data;
      this.data1.data = [];
      this.data1.data = temp;
    },
    // 確認更新排序
    data1SubmitSort() {
      const sortList = [];

      this.data1.data.forEach((item, index) => {
        sortList.push({
          id: item.id,
          sortNumber: index,
        });
      });
      G_Linked_Sort(sortList)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
          });
          this.data1.sort.status = false;
          this.data1GetList();
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: 'warning',
          });
        });
    },

    // data0 add 新增類別
    // 關閉add Dialog
    data0AddForm0DialogClosed() {
      this.data0.addForm0.loading = false;
      this.$refs[this.data0.addForm0.formRef].resetFields();
      this.data0.addForm0.errorMessage = '';
    },

    // data0 add 同名驗證function
    sameCategoryValidate(input) {
      const flag = this.data0.categoryList.find((name) => name.name === input);
      if (flag) {
        this.$confirm('分類名稱已存在，請輸入別的名稱', '無法新增連結', {
          showConfirmButton: false,
          cancelButtonText: '我知道了',
          type: 'warning',
        })
          .then(() => {})
          .catch(() => {});
        return true;
      }
      return false;
    },
    //  增加分類
    data0AddForm0Submit() {
      if (this.sameCategoryValidate(this.data0.addForm0.data.name)) {
        return;
      }
      this.$refs[this.data0.addForm0.formRef].validate((valid) => {
        if (valid) {
          this.data0.addForm0.errorMessage = '';
          this.data0.addForm0.loading = true;
          G_Linked_Category_Add(this.data0.addForm0.data)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
              });
              this.data0.addForm0.dialogVisible = false;
              this.data0GetList();
            })
            .catch((err) => {
              this.data0.addForm0.loading = false;
              this.data0.addFrom0.errorMessage = err.response.data.message;
            });
        }
      });
    },

    // data0 update
    // 開啟編輯分類彈窗
    data0UpdateForm0DialogOpen(index) {
      this.data0.updateForm0.data = { ...this.data0.categoryList[index] };
      this.data0.updateForm0.updateId = this.data0.categoryList[index].id;
      this.data0.updateForm0.dialogVisible = true;
    },
    // 關閉編輯連結彈窗
    data0UpdateForm0DialogClosed() {
      this.data0.updateForm0.loading = false;
      this.$refs[this.data0.updateForm0.formRef].resetFields();
      this.data0.updateForm0.updateId = 0;
      this.data0.updateForm0.errorMessage = '';
    },
    // data0 update function
    data0UpdateForm0Submit() {
      if (this.sameCategoryValidate(this.data0.updateForm0.data.name)) {
        return;
      }
      this.$refs[this.data0.updateForm0.formRef].validate((valid) => {
        if (valid) {
          this.data0.updateForm0.errorMessage = '';
          this.data0.updateForm0.loading = true;
          G_Linked_Category_Update(
            this.data0.updateForm0.updateId,
            this.data0.updateForm0.data,
          )
            .then(() => {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
              });
              this.data0.updateForm0.dialogVisible = false;
              this.data0GetList();
            })
            .catch((err) => {
              this.data0.updateForm0.loading = false;
              this.data0.updateForm0.errorMessage = err.response.data.message;
            });
        }
      });
    },

    // data0 delete
    data0Delete(index) {
      // 先抓出該類別的連結
      G_Linked_GetList(this.data0.categoryList[index].id)
        .then((res) => {
          if (res.data.data.length <= 0) {
            // 如果沒有連結就可以刪除該類別
            this.$confirm('刪除後將無法復原', '確定刪除?', {
              confirmButtonText: '確定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(() => {
                G_Linked_Category_Delete(this.data0.categoryList[index].id)
                  .then(() => {
                    this.$notify({
                      title: '成功',
                      message: '刪除成功',
                      type: 'success',
                    });
                    this.data0GetList();
                  })
                  .catch((err) => {
                    this.$message({
                      message: err.response.data.message,
                      type: 'warning',
                    });
                  });
              })
              .catch(() => {});
          } else {
            // 該類別底下有連結則無法刪除類別
            this.$confirm(
              '該分類底下含有多筆連結，無法刪除，請先刪除連結。',
              '無法刪除該分類',
              {
                showConfirmButton: false,
                cancelButtonText: '我知道了',
                type: 'warning',
              },
            )
              .then(() => {})
              .catch(() => {});
          }
        })
        .catch((err) => {
          this.data1.addForm1.errorMessage = err.response.data.message;
        });
    },

    // data0 sort
    // 暫存原本資料
    data0OpenSortFunction() {
      this.data0.sort.status = true;
      this.data0.sort.originalDataTemp = [...this.data0.categoryList];
    },
    // 回復原本資料
    data0CloseSortFunction() {
      this.data0.sort.status = false;
      this.data0.categoryList = [];
      this.data0.categoryList = [...this.data0.sort.originalDataTemp];
    },
    // 更新排序
    data0SortUpdateIndex(originalIndex, newIndex) {
      [
        this.data0.categoryList[originalIndex],
        this.data0.categoryList[newIndex],
      ] = [
        this.data0.categoryList[newIndex],
        this.data0.categoryList[originalIndex],
      ];
      const temp0 = this.data0.categoryList;
      this.data0.categoryList = [];
      this.data0.categoryList = temp0;
    },
    // 確認更新排序
    data0SubmitSort() {
      const sortList = [];
      this.data0.categoryList.forEach((item, index) => {
        sortList.push({
          id: item.id,
          sortNumber: index,
        });
      });
      G_Linked_Category_Sort(sortList)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
          });
          this.data0.sort.status = false;
          this.data0GetList();
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: 'warning',
          });
        });
    },

    // data0 cancel
    data0EditCancel() {
      this.data0.editDialogVisible = false;
      this.data0CloseSortFunction();
      this.data0GetList();
    },
    // data0 confirm
    data0EditConfirm() {
      this.data0.editDialogVisible = false;
      this.data0SubmitSort();
      this.data0SortUpdateIndex();
      this.data0OpenSortFunction();
      this.data0GetList();
    },

    // 編輯分類click事件
    categoryEditFunction() {
      this.data0.editDialogVisible = true;
      this.data0OpenSortFunction();
      this.data0GetList();
    },

    // 未選擇類別 + 連結function
    LinkedAddFunction() {
      if (this.nowCategoryId === 0) {
        this.$confirm('請先選擇類別後再增加連結', '無法新增連結', {
          showConfirmButton: false,
          cancelButtonText: '我知道了',
          type: 'warning',
        })
          .then(() => {})
          .catch(() => {});
      } else {
        this.data1.addForm1.dialogVisible = true;
      }
    },
  },

  // 根據分類ID變更連結資料
  watch: {
    nowCategoryId() {
      this.data1GetList();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog-body {
  height: 370px;
  overflow: auto;
}
</style>
